import styled from "styled-components";

export const DescriptionImportCsv = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
  margin-top: 20px;
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
`;
